import getBorderFocusStyles from '../../getBorderFocusStyles';
import { pxToRem } from '../../../../utils';
import checkboxIndicatorUrl from '../Checkbox/checkboxIndicatorUrl';
import checkboxIndicatorIndeterminatedUrl from './checkboxIndicatorIndeterminatedUrl';
var treeTitleStyles = {
  root: function root(_ref) {
    var p = _ref.props,
        v = _ref.variables,
        siteVariables = _ref.theme.siteVariables;
    return Object.assign({
      padding: v.padding,
      cursor: 'pointer',
      color: v.color,
      position: 'relative'
    }, p.selectable && {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    }, {}, getBorderFocusStyles({
      variables: siteVariables
    }));
  },
  selectionIndicator: function selectionIndicator(_ref2) {
    var p = _ref2.props,
        v = _ref2.variables;
    return Object.assign({
      display: 'inline-block',
      float: 'right',
      verticalAlign: 'middle',
      boxShadow: 'unset',
      width: pxToRem(16),
      height: pxToRem(16),
      borderColor: v.borderColor,
      borderStyle: v.borderStyle,
      borderRadius: v.borderRadius,
      borderWidth: v.borderWidth,
      color: v.indicatorColor,
      margin: v.selectionIndicatorMargin,
      padding: v.padding,
      userSelect: 'none',
      backgroundImage: checkboxIndicatorUrl(v.indicatorColor, v.background),
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat'
    }, p.selected && {
      borderColor: v.checkedBorderColor,
      backgroundImage: checkboxIndicatorUrl(v.checkedIndicatorColor, v.checkedBackground)
    }, {}, p.indeterminate && {
      borderColor: v.checkedBorderColor,
      backgroundImage: checkboxIndicatorIndeterminatedUrl(v.checkedIndicatorColor, v.checkedBackground)
    }, {}, p.disabled && {
      background: v.disabledBackground,
      borderColor: v.disabledBorderColor
    }, {}, p.disabled && p.selected && {
      color: v.disabledCheckedIndicatorColor,
      borderColor: v.disabledBackgroundChecked,
      backgroundImage: checkboxIndicatorUrl(v.disabledCheckedIndicatorColor, v.disabledBackgroundChecked)
    });
  }
};
export default treeTitleStyles;
//# sourceMappingURL=treeTitleStyles.js.map
